import React, { useState, useRef, useEffect } from 'react';

const StatusDropdownButton = ({ onSubmit, isSubmitting, disabled }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Fermer le dropdown quand on clique à l'extérieur
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const statusOptions = [
    {
      key: 'pending',
      label: 'Ajouter la note et status en attente',
      description: 'Relance faite, on attend que le promoteur remplisse',
      icon: '⏳',
      color: 'text-yellow-600 dark:text-yellow-400'
    },
    {
      key: 'done',
      label: 'Ajouter la note et form rempli',
      description: 'Le promoteur ou l\'opérateur vient de remplir le formulaire',
      icon: '✅',
      color: 'text-green-600 dark:text-green-400'
    },
    {
      key: 'wontdo',
      label: 'Ajouter la note et form abandonné',
      description: 'Le promoteur ne remplira pas le formulaire',
      icon: '❌',
      color: 'text-red-600 dark:text-red-400'
    }
  ];

  const defaultOption = statusOptions[0]; // 'pending' par défaut

  const handleMainAction = () => {
    onSubmit(defaultOption.key);
  };

  const handleOptionSelect = (status) => {
    setIsOpen(false);
    onSubmit(status);
  };

  return (
    <div className="relative inline-flex" ref={dropdownRef}>
      {/* Bouton principal */}
      <button
        type="button"
        onClick={handleMainAction}
        disabled={disabled || isSubmitting}
        className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-l-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {isSubmitting ? (
          <>
            <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            Ajout en cours...
          </>
        ) : (
          <>
            <span className="mr-2">{defaultOption.icon}</span>
            {defaultOption.label}
          </>
        )}
      </button>

      {/* Bouton dropdown */}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled || isSubmitting}
        className="inline-flex items-center px-2 py-2 border border-l-0 border-transparent text-sm font-medium rounded-r-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {/* Menu dropdown */}
      {isOpen && (
        <div className="absolute right-0 bottom-full mb-1 w-80 bg-white dark:bg-gray-800 rounded-md shadow-xl border border-gray-200 dark:border-gray-700 z-[9999]">
          <div className="py-1">
            {statusOptions.map((option) => (
              <button
                key={option.key}
                onClick={() => handleOptionSelect(option.key)}
                className="w-full text-left px-4 py-3 hover:bg-gray-50 dark:hover:bg-gray-700 focus:outline-none focus:bg-gray-50 dark:focus:bg-gray-700 transition-colors"
              >
                <div className="flex items-start space-x-3">
                  <span className={`text-lg ${option.color}`}>
                    {option.icon}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-gray-900 dark:text-gray-100">
                      {option.label}
                    </div>
                    <div className="text-xs text-gray-500 dark:text-gray-400 mt-1">
                      {option.description}
                    </div>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default StatusDropdownButton;